let gifuctJs;

async function loadGifuctJs() {
  if (!gifuctJs) {
    gifuctJs = await import('gifuct-js');
  }
  return gifuctJs;
}

export async function parseGif(arrayBuffer) {
  const module = await loadGifuctJs();
  return module.parseGIF(arrayBuffer);
}

export async function decompressGifFrames(gif) {
  const module = await loadGifuctJs();
  return module.decompressFrames(gif);
}

// Export other functions as needed
